import Vue from 'vue';
import { ActionTree, MutationTree } from 'vuex';
import { RootState } from '@/store/types';
import { ServerResult } from '@/core/http/server_result';
import moment from 'moment';
import { saveAs } from 'file-saver';
import cloneDeep from 'lodash/cloneDeep';
import merge from 'lodash/merge';
import ru from 'apexcharts/dist/locales/ru.json';
import numeral from 'numeral';
import { loadavg } from 'os';
import { head } from 'lodash';
interface TransportCostsByClientReportState {
    loaded: boolean;
    loading: boolean;
    fatalError: boolean;


    filter: {
        dZoneGroups: any;
        targetDates: Date[];
        city_id: any;
        head_city_id: any;
    };

    items: any[];
    payments: any[];
    total: any;
    accepts: any[];

    graphicList: any[];
}

const state: TransportCostsByClientReportState = {
    loading: false,
    loaded: false,
    fatalError: false,

    filter: {
        dZoneGroups: null,
        targetDates: [new Date(), new Date()],
        city_id: null,
        head_city_id: null
    },

    items: [],
    payments: [],
    total: {},
    accepts: [],

    graphicList: [],
};

function buildFilter(params: any) {
    const queryParams: any = {}

    if (params.targetDates) {
        queryParams.date_from = moment(params.targetDates[0]).format('YYYY-MM-DD');
        queryParams.date_to = moment(params.targetDates[1]).format('YYYY-MM-DD')
    }

    if (params.dZoneGroups) {
        queryParams.delivery_zone_group_id = params.dZoneGroups;
    }

    if (params.employees) {
        queryParams.manager_id = params.employees;
    }
    if (params.city_id) {
        queryParams.city_id = params.city_id;
    }
    if (params.group_type) {
        queryParams.group_type = params.group_type;
    }
    if (params.head_city_id) {
        queryParams.head_city_id = params.head_city_id;
    }

    if (params.clients) {
        params.clients = params.clients.filter((item: any) => item != null)
        queryParams.client_ids = Array.isArray(params.clients) ? params.clients : [ params.clients ];
    }

    if (params.sortField !== null) {
        queryParams.order_by = params.sortField || 'client_name';
        queryParams.order_type = params.sortDirection || 'asc';
    }

    return queryParams;
}

export const REPORT_DATA = 'REPORT_DATA';
export const ACCEPTS_LIST = 'GET_ACCEPTS_LIST';
export const PAYMENTS_LIST = 'GET_PAYMENTS_LIST';

export const actions: ActionTree<TransportCostsByClientReportState, RootState> = {

    loadData({ commit, state, dispatch }, params) {
        const vm = (this as any)._vm;

        return new Promise((resolve, reject) => {
            console.log('params', params)
            if (Object.values(params).length > 0) {
                commit('START_LOADING');

                vm.$db([
                    vm.$q(REPORT_DATA)
                        .raw('reports.transport_costs_by_client')
                        .action(buildFilter(params))
                ]).then(((result: ServerResult) => {
                    commit('SET_REPORT_DATA', result.getOperation(REPORT_DATA).getContent());
                    commit('LOADED_SUCCESS');

                    resolve();
                }));
            } else {
                resolve();
            }
        })
    },

    exportDataAsXLSX({rootState}, params) {
        const vm = (this as any)._vm;

        return new Promise((resolve, reject) => {
            vm.$db([
                vm.$q('EXPORT')
                .raw('reports.transport_costs_by_client.export')
                .action({ ...buildFilter(params), format: 'xlsx'})
            ]).then(((result: ServerResult) => {
                const exportOpContent = result.getOperation('EXPORT').getContent();
                const fToken = exportOpContent.token;
                const aToken = (rootState as any).ubic.token
                const fileUrl = `${process.env.VUE_APP_UBIC_SERVER_ADDRESS}/api/v1/exports/${fToken}?authorization=${aToken}`;
                saveAs(fileUrl, 'export.xlsx')

                resolve();
            }));
        })
    },

    removeItem({state, dispatch}, row) {
        const vm = (this as any)._vm;
        return new Promise((resolve, reject) => {
            vm.$db([
                vm.$q('EXPORT')
                .raw('documents.delete')
                .action({id: row.id})
            ]).then(((result: ServerResult) => {
                resolve(null);
            }));
        })
    },

    removeItems({state, dispatch}, rows) {
        const vm = (this as any)._vm;
        return new Promise((resolve, reject) => {
            const actions = rows.map((item: any) => {
                return vm.$q(`RM-${item.id}`).raw('documents.delete').action({id: item.id})
            })
            vm.$db(actions).then(((result: ServerResult) => {
                resolve(null);
            }));
        })
    }
};

export const mutations: MutationTree<TransportCostsByClientReportState> = {
    START_LOADING: (state) => {
        state.loaded = false;
        state.loading = true;
        state.fatalError = false;
    },
    LOADED_SUCCESS: (state) => {
        state.loaded = true;
        state.loading = false;
        state.fatalError = false;
    },
    LOADED_ERROR: (state) => {
        state.loaded = true;
        state.loading = false;
        state.fatalError = true;
    },

    SET_REPORT_DATA(state, data) {
        state.items = data.documents;
        state.total = data.sums;
    }
};

const getters = {
    byMonthy: (state: TransportCostsByClientReportState) => {
        const accepts: any = {
            0: {month: moment().format('YYYY-01-01')},
            1: {month: moment().format('YYYY-02-01')},
            2: {month: moment().format('YYYY-03-01')},
            3: {month: moment().format('YYYY-04-01')},
            4: {month: moment().format('YYYY-05-01')},
            5: {month: moment().format('YYYY-06-01')},
            6: {month: moment().format('YYYY-07-01')},
            7: {month: moment().format('YYYY-08-01')},
            8: {month: moment().format('YYYY-09-01')},
            9: {month: moment().format('YYYY-10-01')},
            10: {month: moment().format('YYYY-11-01')},
            11: {month: moment().format('YYYY-12-01')},
        }

        state.accepts.map((item: any) => {
            accepts[parseInt(moment(item.month).format('MM')) - 1] = item
        })

        return accepts
    },

    totalPayments: (state: TransportCostsByClientReportState) => {
        return state.payments.reduce((val: any, item: any) => {
            // console.log(item)
            return val + parseFloat(item.payment)
        }, 0)
    }

};

export const STORE_KEY = '$_transport_costs_by_client_report';

export const store = {
    namespaced: true,
    state,
    actions,
    getters,
    mutations,
};
